module.exports = __webpack_public_path__ + "img/reference07.ab1b5488.jpg";